<template>
  <el-dialog :visible.sync="visible" title="发票号领用" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="客户：" prop="customerId">
        <customer v-model="dataForm.customerId"></customer>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import CommonDrop from '@/components/CommonDrop'

export default {
  components: { CommonDrop },
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {}
    }
  },
  computed: {
    dataRule () {
      return {
        customerId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        id: '',
        virtualCode: '',
        customerId: ''
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init (ids, virtualCode) {
      this.reset()
      this.ids=ids
      this.dataForm.ids = ids
      this.dataForm.virtualCode = virtualCode
      this.visible = true
    },
    //发票号申领
    async getCode () {
      const res = await this.$api2.post(`/erp/box/code/get`, {
        ids: this.dataForm.ids,
        customerId: this.dataForm.customerId
      })
      this.$message.success('操作成功')
      this.$emit('refreshDataList')
      this.visible=false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.getCode()
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
